import FeatherIcon from "feather-icons-react";
import {
  Card,
  CardBody,
  Table,
  Row,
  Col,
  Spinner,
  Tooltip,
  Button,
} from "reactstrap";
import { useState } from "react";
import { TripModal } from "../../Components/Common/TripModal/tripModal";
import DriverIcon from "../../assets/images/svg/Driver.svg";
import { useNavigate } from "react-router-dom";
import Distance from "../../assets/images/svg/locationpin.svg";
import DeliveryTruck from "../../assets/images/svg/delivery-truck.svg";
import Action from "../../assets/images/svg/Action.svg";
import "./style.scss";

export const RealTimeList = ({ tripData, focusOnMarker, loading }) => {
  const [viewDetails, setViewDetails] = useState(false);
  const [tripDetails, setTripDetails] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [tooltipOpenId, setTooltipOpenId] = useState(null);
  const navigate = useNavigate();
  const toggleViewDetailModal = (data) => {
    setTripDetails(data);
    setViewDetails(!viewDetails);
  };

  const toggleTooltip = (id, data) => {
    setTooltipOpenId((prev) => (prev === id ? null : id));
    setTripDetails(data);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleSwitch = () => {
    setIsSwitchOn(!isSwitchOn);
  };

  const viewMoreTrips = () => {
    navigate("/real-time");
  };

  return (
    <>
      <Card className="realTimeTripCard">
        <CardBody>
          <div className="input-group search-bar">
            <span className="input-group-text bg-light border-0">
              <i className="ri-search-line text-muted"></i>
            </span>
            <input
              type="text"
              className="form-control bg-light border-0"
              placeholder="Search input text"
            />
          </div>

          <Table className="mb-0" striped>
            <thead>
              <tr>
                <th className="tableHeaderText"></th>
                <th className="tableHeaderText"><img src={DeliveryTruck} style={{ width: "24px", height: "24px" }} alt="" /></th>
                <th className="tableHeaderText">
                  <img src={DriverIcon} alt="" />
                </th>
                <th className="tableHeaderText">
                  <img src={Action} alt="" style={{ width: "24px", height: "24px" }} />
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    <Spinner color="primary" />
                  </td>
                </tr>
              ) : tripData.length > 0 ? (
                tripData.map((trip, index) => {
                  const tooltipId = `truckNameTooltip-${index}`;
                  const firstName = trip.truck_name?.split(" ")[0] || "-";
                  const remainingName =
                    trip.truck_name?.split(" ").slice(1).join(" ") || "-";

                  return (
                    <tr key={index} className="hover-row">
                      <td>
                        <img
                          src={trip.icon_url}
                          alt=""
                          style={{ width: "32px", height: "32px" }}
                        />
                      </td>

                      <td id={tooltipId}>
                        {trip.truck_name ? (
                          <>
                            <span
                              style={{ cursor: "pointer", fontWeight: "bold" }}
                            >
                              {firstName}
                            </span>
                            <Tooltip
                              placement="top"
                              isOpen={tooltipOpenId === trip.id}
                              target={tooltipId}
                              toggle={() => toggleTooltip(trip.id, trip)}
                              className="custom-tooltip"
                              autohide={false}
                            >
                              <div className="tooltip-row">
                                <span className="tooltip-label">
                                  Truck Name
                                </span>
                                <span className="tooltip-value">
                                  {tripDetails.truck_name || "-"}
                                </span>
                              </div>
                              <div className="tooltip-row">
                                <span className="tooltip-label">
                                  Driver Name
                                </span>
                                <span className="tooltip-value">
                                  {tripDetails.driver || "-"}
                                </span>
                              </div>
                              <div className="tooltip-row">
                                <span className="tooltip-label">
                                  Distance (km)
                                </span>
                                <span className="tooltip-value">
                                  {tripDetails.distance_km || "-"}
                                </span>
                              </div>
                              <div className="tooltip-row">
                                <span className="tooltip-label">Speed</span>
                                <span className="tooltip-value">
                                  {tripDetails.speed || "-"}
                                </span>
                              </div>
                              <div className="tooltip-row">
                                <span className="tooltip-label">Hours</span>
                                <span className="tooltip-value">
                                  {tripDetails.hours || "-"}
                                </span>
                              </div>
                              <div className="tooltip-row">
                                <span className="tooltip-label">
                                  Satellite Count
                                </span>
                                <span className="tooltip-value">
                                  {tripDetails.satellite_count || "-"}
                                </span>
                              </div>
                              <div className="tooltip-row no-border">
                                <span className="tooltip-label">Location</span>
                                <span className="tooltip-value location">
                                  {tripDetails.location || "-"}
                                </span>
                              </div>
                            </Tooltip>
                            <div className="table_text">
                              {remainingName !== "-"
                                ? remainingName + "..."
                                : "-"}
                            </div>
                          </>
                        ) : (
                          "-"
                        )}
                      </td>

                      <td>
                        {trip.driver?.length > 5
                          ? `${trip.driver.slice(0, 5)}...`
                          : trip.driver || "-"}
                      </td>

                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <FeatherIcon
                            icon="bell"
                            onClick={toggleModal}
                            className={`cursor-pointer text-${trip.status === "red"
                                ? "danger"
                                : trip.status === "yellow"
                                  ? "warning"
                                  : "dark"
                              }`}
                          />
                          <i
                            className="ri-external-link-line cursor-pointer"
                            style={{ fontSize: "22px", color: "#0F62FE" }}
                            onClick={() => focusOnMarker(trip.lat, trip.lng)}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7" className="text-start text-sm-center">
                    <h5>No Trips Found</h5>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>

        <TripModal
          isModalOpen={viewDetails}
          toggleModal={toggleViewDetailModal}
          buttonText="Assign"
          closeText={"Close without saving"}
          title={"In real time"}
          tripText={"Trip Details"}
          showButtons={false}
          showDeleteIcon={false}
          showEditIcon={false}
        >
          <div className="px-3 d-flex flex-column gap-4">
            <Row className="mb-5">
              <Col md={6}>
                <div className="d-flex flex-column gap-5">
                  <div className="d-flex flex-column gap-3">
                    <span className="userDetailLabel">Truck Name</span>
                    <span className="userDetailValue">
                      {tripDetails.truck_name || "-"}
                    </span>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <span className="userDetailLabel">Distance (km)</span>
                    <span className="userDetailValue">
                      {tripDetails.distance_km || "-"}
                    </span>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <span className="userDetailLabel">Hours</span>
                    <span className="userDetailValue">
                      {tripDetails.hours || "-"}
                    </span>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="d-flex flex-column gap-5">
                  <div className="d-flex flex-column gap-3">
                    <span className="userDetailLabel">Driver Name</span>
                    <span className="userDetailValue">
                      {tripDetails.driver || "-"}
                    </span>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <span className="userDetailLabel">Speed</span>
                    <span className="userDetailValue">
                      {tripDetails.speed || "-"}
                    </span>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <span className="userDetailLabel">Satellite Count</span>
                    <span className="userDetailValue">
                      {tripDetails.satellite_count || "-"}
                    </span>
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <div className="d-flex flex-column gap-2 mt-4">
                  <span className="userDetailLabel">Location</span>
                  <span
                    className="userDetailValue"
                    style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    {tripDetails.location || "-"}
                  </span>
                </div>
              </Col>
            </Row>
          </div>
        </TripModal>

        <TripModal
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          buttonText="OK"
          title={"Real-time travel"}
          tripText={"Trip ID: 23699"}
        >
          <div className="px-3 d-flex flex-column gap-4">
            <span>There is an alarm connected to this trip. </span>
            <span>Solve the problem!</span>
            <span>
              Is the problem solved? . Only in this case do you turn off the
              alarm.{" "}
            </span>

            <div className="switch-container">
              <div
                className={`custom-switch ${isSwitchOn ? "on" : "off"}`}
                onClick={toggleSwitch}
              >
                <div className="switch-toggle">
                  {isSwitchOn ? (
                    <FeatherIcon icon="check" size={12} />
                  ) : (
                    <FeatherIcon icon="x" size={12} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </TripModal>
      </Card>
      {tripData.length > 0 && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button className="viewMore" onClick={viewMoreTrips}>
            View more trip list <FeatherIcon icon="external-link" size={16} />
          </Button>
        </div>
      )}
    </>
  );
};
